import React from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Database, ArrowClockwise, Play, Pause } from "@phosphor-icons/react";

export default function ImportPanel({ data, advancedMode, onReload }) {
  const trigger = async () => {
    await api.post("/admin/import/trigger");
    toast.success("Import déclenché");
    setTimeout(onReload, 1500);
  };
  const triggerFullRescan = async () => {
    try {
      await api.post("/admin/import/full-rescan");
      toast.success("Rescan complet INSEE démarré — peut durer 1 à 2 h.");
      setTimeout(onReload, 1500);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erreur");
    }
  };
  const togglePause = async () => {
    if (data.import.paused) await api.post("/admin/import/resume");
    else await api.post("/admin/import/pause");
    onReload?.();
  };

  return (
    <div data-testid="admin-import">
      <div className="bg-card border border-border rounded-sm p-6 mb-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div>
            <div className="label-uppercase mb-1">Import API recherche-entreprises</div>
            <div className="text-sm text-muted-foreground">Statut : <span className="font-semibold text-foreground">{data.import.running ? "En cours" : data.import.paused ? "En pause" : "Inactif"}</span></div>
            <div className="text-sm text-muted-foreground">Dernier passage : {data.import.last_run || "—"}</div>
          </div>
          <div className="flex flex-wrap gap-2">
            {advancedMode && (
              <>
                <button onClick={trigger} className="bg-primary text-primary-foreground hover:bg-[#0f3d29] hover:text-white px-4 py-2 rounded-sm text-sm font-semibold flex items-center gap-2" data-testid="trigger-import"><ArrowClockwise size={14}/> Importer maintenant</button>
                <button onClick={triggerFullRescan} disabled={data.import.rescan_running} className="bg-secondary text-secondary-foreground hover:bg-[#b56847] hover:text-white px-4 py-2 rounded-sm text-sm font-semibold flex items-center gap-2 disabled:opacity-60" data-testid="trigger-full-rescan" title="Itère toutes les sections NAF du 68 avec fallback par code postal — couvre toutes les fiches INSEE actives">
                  <Database size={14}/> {data.import.rescan_running ? "Rescan en cours…" : "Rescan complet INSEE"}
                </button>
                <button onClick={togglePause} className="border border-border hover:border-foreground px-4 py-2 rounded-sm text-sm font-semibold flex items-center gap-2" data-testid="toggle-pause">
                  {data.import.paused ? <><Play size={14}/> Reprendre</> : <><Pause size={14}/> Pause</>}
                </button>
              </>
            )}
            {!advancedMode && (
              <span className="text-xs text-muted-foreground italic">✅ Import auto horaire actif — activer le mode avancé pour les contrôles manuels.</span>
            )}
          </div>
        </div>
        {data.import.rescan_running && data.import.rescan_progress && (
          <div className="mt-4 flex items-center gap-2 text-xs text-muted-foreground" data-testid="rescan-progress">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full rounded-full bg-secondary opacity-75 animate-ping" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-secondary" />
            </span>
            Rescan en cours · section <b className="text-foreground">{data.import.rescan_progress.section}</b> · {data.import.rescan_progress.inserted} insérées
          </div>
        )}
      </div>

      <div className="bg-card border border-border rounded-sm overflow-hidden">
        <div className="px-6 py-4 border-b border-border font-display font-medium">Logs récents</div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm min-w-[640px]">
            <thead className="bg-accent/30 text-xs uppercase tracking-wider text-muted-foreground">
              <tr><th className="text-left px-4 py-2">Démarré</th><th className="text-right px-4 py-2">Récupérés</th><th className="text-right px-4 py-2">Insérés</th><th className="text-right px-4 py-2">Sautés</th><th className="text-right px-4 py-2">Erreurs</th><th className="text-left px-4 py-2">Statut</th></tr>
            </thead>
            <tbody>
              {data.import.last_logs.map((l, i) => (
                <tr key={l.started_at || i} className="border-t border-border">
                  <td className="px-4 py-2 text-xs">{l.started_at}</td>
                  <td className="text-right px-4 py-2 tabular-nums">{l.fetched}</td>
                  <td className="text-right px-4 py-2 tabular-nums font-semibold">{l.inserted}</td>
                  <td className="text-right px-4 py-2 tabular-nums text-muted-foreground">{l.skipped}</td>
                  <td className="text-right px-4 py-2 tabular-nums text-destructive">{l.errors}</td>
                  <td className="px-4 py-2 text-xs"><span className="inline-block px-2 py-0.5 bg-accent rounded-sm">{l.status}</span></td>
                </tr>
              ))}
              {data.import.last_logs.length === 0 && <tr><td colSpan="6" className="text-center text-muted-foreground py-6">Pas encore de logs.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
